export class ModuleNotFoundError extends Error {
    constructor(filepath, parent) {
        super(`Cannot find module '${filepath}' from '${parent}'`);
        this.code = 'MODULE_NOT_FOUND';
        this.parent = parent;
        this.filepath = filepath;
    }
}
